import React, { useEffect } from "react";
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Blog from './components/Blog/Blog';
import NotFound from './components/NotFound/NotFound';

import { VStack } from "@chakra-ui/react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import KoreaBlog from "./components/Blog/Korea/KoreaBlog";
import FirstMonthBlog from "./components/Blog/FirstMonthCornell/FirstMonthBlog";
import BethpageBlackBlog from "./components/Blog/BethpageBlackBlog/BethpageBlackBlog";
import HalfMarathon from "./components/Blog/HalfMarathon/HalfMarathon";
import GoogleBlog from "./components/Blog/GoogleBlog/GoogleBlog";

import Summer2025Intern from "./components/Private/Summer2025Intern";
import Resume from "./components/Private/Resume";
import NewGrad2026 from "./components/Private/NewGrad2026";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


function App() {

  return (
    <div>
      <Navbar />

      <VStack>
        <Router>
          <ScrollToTop />

          <div className="App" >

            <Routes>
              {/* Routes */}
              <Route path = "/" element = {<Home />} />
              <Route path = "/about" element = {<About />} />
              <Route path = "/blog" element = {<Blog />} />
              <Route path = "/KoreaBlog" element = {<KoreaBlog />} />
              <Route path = "/CornellBeginnings" element = {<FirstMonthBlog />} />
              <Route path = "/BethpageBlack" element = {<BethpageBlackBlog />} />
              <Route path = "/HalfMarathon" element = {<HalfMarathon />} />
              <Route path="/resume" element={<Resume />} />

              {/* Hidden Routes */}
              <Route path="/Summer2025Internships" element={<Summer2025Intern />} />
              <Route path="/NewGrad2026" element={<NewGrad2026 />} />
              <Route path="/GoogleBlog" element={<GoogleBlog />} />

              {/* Not Found Route */}
              <Route path="*" element={<NotFound />} />


            </Routes>
          </div>

        </Router>
      </VStack>
      <Footer />
    </div>
  );
}

export default App;
